// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".more-btn[data-v-1f01f308]{bottom:0;position:absolute;right:24px}.more-btn__icon[data-v-1f01f308]{margin-top:3px}.title-image[data-v-1f01f308]{max-height:250px;width:100%}.position-relative[data-v-1f01f308]{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
